function getSubdomainFromURL(): string | null {
  if (typeof window === 'undefined') return null;

  const hostname = window.location.hostname;

  // Handle localhost cases
  if (hostname === 'localhost' || hostname.startsWith('127.') || hostname === '0.0.0.0') {
    return null;
  }

  // Extract subdomain from hostname (e.g., "krishna.qaapifyxt.com" -> "krishna")
  const parts = hostname.split('.');

  // For domains like "subdomain.domain.com", the subdomain is the first part
  // For "qaapifyxt.com" or "devapifyxt.com", we check if there's a subdomain
  if (parts.length >= 3) {
    // Check if first part is not 'www'
    if (parts[0] !== 'www' && parts[0] !== 'web') {
      return parts[0];
    }
  }

  // For two-part domains, check if we can extract from URL path or query params
  // This handles cases where subdomain might be in the URL path
  const urlParams = new URLSearchParams(window.location.search);
  const subdomainFromParam = urlParams.get('subdomain') || urlParams.get('clientId');
  if (subdomainFromParam) {
    return subdomainFromParam;
  }

  return null;
}

// Get subdomain from URL or use default
const subdomain = getSubdomainFromURL();
const defaultClientId = 'web';
const defaultLocalDevURL = 'https://web.devapifyxt.com/v1/';

// Set clientId and LocalDev_URL dynamically
const clientId = subdomain || defaultClientId;
const LocalDev_URL = subdomain
  ? `https://${subdomain}.devapifyxt.com/v1/`
  : defaultLocalDevURL;

// Set auth0 domain and redirectUri dynamically using the same clientId
export const auth0DomainDev = `https://${clientId}.devfyxt.com`;
export const auth0RedirectUriDev = `https://${clientId}.devfyxt.com`;

export const auth0DomainQa = `https://${clientId}.qafyxt.com`;
export const auth0RedirectUriQa = `https://${clientId}.qafyxt.com`;

export const auth0DomainProd = `https://${clientId}.fyxt.com`;
export const auth0RedirectUriProd = `https://${clientId}.fyxt.com`;
